import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(( theme ) => ({
  submitButton: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: '50%',
    },
  },
  content: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: '50%',
      margin: 'auto'
    }
  }
}));